import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { Formik, Form } from 'formik';
import GridContainer from '../GridContainer';
import '../../components/CommonFilter/filter.scss';

const ActiveFilter = ({ onFilter, initialFormState }) => {
  const formRef = useRef();

  const submitForm = (values) => {
    onFilter(values);
  };

  const save = () => {
    formRef.current.submitForm();
  };

  return (
    <Formik
      innerRef={formRef}
      initialValues={{ ...initialFormState }}
      enableReinitialize
      onSubmit={(values) => submitForm(values)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <GridContainer className="commonFilter">
            <div>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Status</InputLabel>
                <Select
                  value={values.isActive}
                  label="Status"
                  onChange={({ target: { value } }) => setFieldValue('isActive', value)}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <Button onClick={save} color="primary" variant="contained">
                Filter
              </Button>
            </div>
          </GridContainer>
        </Form>
      )}
    </Formik>
  );
};

ActiveFilter.propTypes = {
  onFilter: PropTypes.func,
  initialFormState: PropTypes.object
};

export default ActiveFilter;
